// TODO: Eliminate this singleton in the future.
export const devPageFiles = new Set<string>()
